/**
 * EHR Extension Promo Slice
 *
 * Persisted Redux slice tracking promo popup dismissal state.
 *
 * - dismissed: true → permanently hidden (user clicked X or "Learn More")
 * - snoozedUntil: timestamp → hidden until that time (user clicked "Maybe later")
 */

import { createSlice } from '@reduxjs/toolkit';

const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export interface EhrExtensionPromoState {
  dismissed: boolean;
  snoozedUntil: number | null; // Unix timestamp (ms)
}

const initialState: EhrExtensionPromoState = {
  dismissed: false,
  snoozedUntil: null,
};

export const ehrExtensionPromoSlice = createSlice({
  name: 'ehrExtensionPromo',
  initialState,
  reducers: {
    /** Permanently dismiss the promo (X button or "Learn More") */
    dismissPromo: (state) => {
      state.dismissed = true;
      state.snoozedUntil = null;
    },

    /** Snooze the promo for 1 week ("Maybe later") */
    snoozePromo: (state) => {
      state.snoozedUntil = Date.now() + ONE_WEEK_MS;
    },

    /** Reset promo state (for testing/debugging) */
    resetPromo: () => initialState,
  },
});

export const { dismissPromo, snoozePromo, resetPromo } = ehrExtensionPromoSlice.actions;

export default ehrExtensionPromoSlice.reducer;
